export default "__VITE_ASSET__iFBmijj0__"